import { CloseIcon } from "../Icons";
import { Link } from "../Link";
import styles from "./StatusScreen.module.scss";

type StatusScreenProps = {
  title: string;
  description: string;
  onClose: () => void;
};

export const StatusScreen = ({ title, description, onClose }: StatusScreenProps) => {
  return (
    <div className={styles.statusScreen}>
      <div className={styles.closeIconWrapper} onClick={onClose}>
        <CloseIcon className={styles.closeIcon} />
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
      <Link href="/" className={styles.link} text="Back to Home page" />
    </div>
  );
};
